// extracted by mini-css-extract-plugin
export var actionButton = "_wz-2";
export var card = "_wz-0";
export var errorCard = "_wz-1";